<div class="wrap">
  <div class="title">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" (click)="back()" appChangeColorTheme attribute="color">
    </fa-icon>
    <h2>Liste des fichiers</h2>
  </div>

  <div class="file" id="file" appDragDropFileOffer>
    <input type="file" #fileDropRef id="fileDropRef" multiple (change)="uploadFiles($event.target.files)" />

    <div class="loading" *ngIf="loadingDocuments || loadingImages">
      <mat-spinner [diameter]="75"></mat-spinner>
    </div>

    <p class="message_drag_drop_file">Glissez votre fichier ici </p>

    <div class="or">
      <span>Ou</span>
    </div>

    <div class="input_file">
      <button>Parcourir les fichiers</button>
      <input type="file" multiple (change)="uploadFiles($event.target.files)">

    </div>
  </div>

  <p class="size_max">
    <fa-icon [icon]="getFaIcon('faInfoCircle')" class="iconInfo"></fa-icon>
    Taille max. 3MB pour les pdf et taille max. 500kB pour les images, privilégier format paysage 16/9
  </p>

  <div class="list_file">
    <h4 appChangeColorTheme attribute="bgc" rgba="0.2">Liste des documents</h4>
    <p *ngIf="documents?.length === 0 && !loadingDocuments">Aucun document</p>
    <ul *ngIf="documents?.length > 0 && !loadingDocuments">
      <li *ngFor="let f of documents">
        <span>{{f.fileName}}</span>

        <div class="btn_action">
          <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
            (click)="downloadFile(f.offerKey, f.offerFileKey,f.fileName )"></fa-icon>
          <fa-icon [icon]="getFaIcon('faTrashAlt')" [matTooltip]="'Supprimer'"
            (click)="deleteFile(f.offerKey, f.offerFileKey)">
          </fa-icon>
        </div>
      </li>
    </ul>
    <mat-spinner class="loadingSpinner" *ngIf="loadingDocuments" [diameter]="75"></mat-spinner>


    <h4 appChangeColorTheme attribute="bgc" rgba="0.2">Liste des images</h4>
    <p *ngIf="imagesForSlideShow?.length === 0 && !loadingImages">Aucune image</p>
    <ul *ngIf="imagesForSlideShow?.length > 0 && !loadingImages">
      <li *ngFor="let f of imagesForSlideShow">
        <span>{{f.fileName}}</span>

        <div class="btn_action">
          <!-- <fa-icon [icon]="getFaIcon('faDownload')" [matTooltip]="'Télécharger'"
            (click)="downloadFile(f.offerKey, f.offerPictureKey,f.fileName )"></fa-icon> -->
          <fa-icon [icon]="getFaIcon('faTrashAlt')" [matTooltip]="'Supprimer'" (click)="deleteImage(f.offerPictureKey)">
          </fa-icon>
        </div>
      </li>
    </ul>
    <mat-spinner class="loadingSpinner" *ngIf="loadingImages" [diameter]="75"></mat-spinner>
  </div>
</div>